import OrganizationStats from './OrganizationStats';

export default OrganizationStats;
